"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
require("reflect-metadata");
var sub_events_1 = require("sub-events");
var AuthManager_1 = require("./helpers/AuthManager");
var Logger_1 = require("./helpers/Logger");
var RestApiConnector_1 = require("./helpers/RestApiConnector");
var GraphQLConnector_1 = require("./helpers/GraphQLConnector");
var WebsocketsConnector_1 = require("./helpers/WebsocketsConnector");
var Errors_1 = require("./helpers/Errors");
var models_1 = require("./resources/models");
var RetryPolicy_1 = require("./helpers/RetryPolicy");
var factories_1 = require("./resources/factories");
var Chariot = /** @class */ (function () {
    function Chariot(options) {
        var _this = this;
        this.onLoginStateChanged = new sub_events_1.SubEvent();
        this.onGlobalSettingsChanged = new sub_events_1.SubEvent();
        this.onClientSettingsChanged = new sub_events_1.SubEvent();
        this.options = options;
        this.Client = new factories_1.ClientFactory(this);
        this.Equipment = new factories_1.EquipmentFactory(this);
        this.RuleEvent = new factories_1.RuleEventFactory(this);
        this.Floorplan = new factories_1.FloorplanFactory(this);
        this.Point = new factories_1.PointFactory(this);
        this.Preset = new factories_1.PresetFactory(this);
        this.Rule = new factories_1.RuleFactory(this);
        this.Schedule = new factories_1.ScheduleFactory(this);
        this.Site = new factories_1.SiteFactory(this);
        this.SiteGroup = new factories_1.SiteGroupFactory(this);
        this.User = new factories_1.UserFactory(this);
        this.auth = new AuthManager_1.default(this);
        this.logger = new Logger_1.default(options.logLevel || "info");
        this.RestApi = new RestApiConnector_1.default(this.auth);
        this.GraphQL = new GraphQLConnector_1.default(this.auth);
        if (!options.noPulse)
            this.Pulse = new WebsocketsConnector_1.default(this.auth, this.logger);
        this.auth.onAuthUpdated.subscribe(function () { return _this.refreshLoginState(); });
    }
    Chariot.prototype.getClient = function () {
        try {
            if (!this.auth.getState().authenticated || !this.loginState) {
                throw new Errors_1.OrderOfOperationsError("Attempted to access client data before logging in.");
            }
            return new models_1.Client(this.loginState.client, this);
        }
        catch (e) {
            this.logger.catch(e);
            throw e;
        }
    };
    Chariot.prototype.getLoggedInUser = function () {
        try {
            if (!this.auth.getState().authenticated || !this.loginState) {
                throw new Errors_1.OrderOfOperationsError("Attempted to access client data before logging in.");
            }
            var me = new models_1.User(this.loginState.user, this);
            return me;
        }
        catch (e) {
            this.logger.catch(e);
            throw e;
        }
    };
    Chariot.prototype.waitForLogin = function () {
        var _this = this;
        return new Promise(function (resolve) {
            if (_this.loginState && _this.loginState.user) {
                resolve();
                return;
            }
            var subscription = _this.onLoginStateChanged.subscribe(function (state) {
                if (state && state.user) {
                    subscription.cancel();
                    resolve();
                }
            });
        });
    };
    Chariot.prototype.login = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.RestApi.login(payload)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.waitForLogin()];
                    case 2:
                        _a.sent();
                        this.logger.log("Successfully logged in");
                        return [2 /*return*/, this.auth.getState()];
                    case 3:
                        e_1 = _a.sent();
                        this.logger.catch(e_1);
                        throw e_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Chariot.prototype.refreshLogin = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.RestApi.refreshLogin(payload)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.waitForLogin()];
                    case 2:
                        _a.sent();
                        this.logger.log("Refreshed login using token");
                        return [2 /*return*/, this.auth.getState()];
                    case 3:
                        e_2 = _a.sent();
                        this.logger.catch(e_2);
                        throw e_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Chariot.prototype.verifyWriteAccess = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.waitForLogin()];
                    case 1:
                        _a.sent();
                        if (!this.loginState) {
                            throw new Errors_1.OrderOfOperationsError("Attempted to verify write access before logging in.");
                        }
                        if (!this.loginState.user.can_edit) {
                            throw new Errors_1.UnauthorizedError("User does not have write access");
                        }
                        return [2 /*return*/, this.loginState.user.can_edit];
                    case 2:
                        e_3 = _a.sent();
                        this.logger.catch(e_3);
                        throw e_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Chariot.prototype.verifyAdminAccess = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.waitForLogin()];
                    case 1:
                        _a.sent();
                        if (!this.loginState) {
                            throw new Errors_1.OrderOfOperationsError("Attempted to access user permissions before logging in.");
                        }
                        if (this.loginState.user.scope == "admin") {
                            this.logger.debug("Successfully verified admin access");
                            return [2 /*return*/, true];
                        }
                        throw new Errors_1.UnauthorizedError("User is not an admin.");
                    case 2:
                        e_4 = _a.sent();
                        this.logger.catch(e_4);
                        throw e_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Chariot.prototype.refreshLoginState = function () {
        return __awaiter(this, void 0, void 0, function () {
            var loginState, e_5, e_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 7, , 8]);
                        if (!this.auth.getState().authenticated) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.RestApi.request({
                                path: "/me",
                                retryPolicy: new RetryPolicy_1.RetryPolicy({ maxRetries: 0 })
                            })];
                    case 2:
                        loginState = _a.sent();
                        this.loginState = loginState;
                        return [3 /*break*/, 4];
                    case 3:
                        e_5 = _a.sent();
                        if (this.auth.getState().authenticated)
                            this.auth.setState(AuthManager_1.DEFAULT_AUTH_STATE);
                        return [2 /*return*/];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        delete this.loginState;
                        _a.label = 6;
                    case 6:
                        this.logger.debug("Updated login state");
                        this.onLoginStateChanged.emit(this.loginState);
                        return [3 /*break*/, 8];
                    case 7:
                        e_6 = _a.sent();
                        this.logger.catch(e_6);
                        throw e_6;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    Chariot.prototype.requestResetCode = function (_a) {
        var email = _a.email;
        return __awaiter(this, void 0, void 0, function () {
            var response, e_7;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.RestApi.request({
                                method: "POST",
                                authenticated: false,
                                path: "/users/password",
                                body: {
                                    email: email
                                }
                            })];
                    case 1:
                        response = _b.sent();
                        this.logger.log("Sent password reset email to ".concat(email));
                        return [2 /*return*/, response.success];
                    case 2:
                        e_7 = _b.sent();
                        this.logger.catch(e_7);
                        throw e_7;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Chariot.prototype.resetPassword = function (_a) {
        var code = _a.code, password = _a.password;
        return __awaiter(this, void 0, void 0, function () {
            var response, e_8;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.RestApi.request({
                                method: "PUT",
                                authenticated: false,
                                path: "/users/password",
                                body: {
                                    code: code,
                                    password: password
                                }
                            })];
                    case 1:
                        response = _b.sent();
                        this.logger.log("Successfully reset password");
                        return [2 /*return*/, response.success];
                    case 2:
                        e_8 = _b.sent();
                        this.logger.catch(e_8);
                        throw e_8;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Chariot.prototype.getUserSettings = function (refresh) {
        var _a, _b;
        if (refresh === void 0) { refresh = false; }
        return __awaiter(this, void 0, void 0, function () {
            var newUserSettings, e_9;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        if (!this.auth.getState().authenticated) {
                            throw new Errors_1.OrderOfOperationsError("Attempted to access user settings before logging in.");
                        }
                        if (!refresh && this.userSettings)
                            return [2 /*return*/, this.userSettings];
                        return [4 /*yield*/, this.RestApi.request({
                                path: "/ambience/user_settings"
                            })];
                    case 1:
                        newUserSettings = _c.sent();
                        this.logger.log("Retrieved user settings");
                        if (JSON.stringify(newUserSettings.client_settings) !== JSON.stringify((_a = this.userSettings) === null || _a === void 0 ? void 0 : _a.client_settings)) {
                            this.onClientSettingsChanged.emit(newUserSettings.client_settings);
                        }
                        if (JSON.stringify(newUserSettings.global_settings) !== JSON.stringify((_b = this.userSettings) === null || _b === void 0 ? void 0 : _b.global_settings)) {
                            this.onGlobalSettingsChanged.emit(newUserSettings.global_settings);
                        }
                        this.userSettings = newUserSettings;
                        return [2 /*return*/, this.userSettings];
                    case 2:
                        e_9 = _c.sent();
                        this.logger.catch(e_9);
                        throw e_9;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Chariot.prototype.updateUserSettings = function (settings) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var newUserSettings, updatedUserSettings, e_10;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 4, , 5]);
                        if (!this.auth.getState().authenticated) {
                            throw new Errors_1.OrderOfOperationsError("Attempted to update user settings before logging in.");
                        }
                        newUserSettings = __assign({}, this.userSettings);
                        if (!!this.userSettings) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getUserSettings()];
                    case 1:
                        newUserSettings = _c.sent();
                        _c.label = 2;
                    case 2:
                        if ("client_settings" in settings) {
                            newUserSettings.client_settings = __assign(__assign({}, newUserSettings.client_settings), settings.client_settings);
                        }
                        if ("global_settings" in settings) {
                            newUserSettings.global_settings = __assign(__assign({}, newUserSettings.global_settings), settings.global_settings);
                        }
                        return [4 /*yield*/, this.RestApi.request({
                                path: "/ambience/user_settings",
                                method: "PUT",
                                body: newUserSettings
                            })];
                    case 3:
                        updatedUserSettings = _c.sent();
                        this.logger.log("Updated user settings");
                        if (JSON.stringify(updatedUserSettings.client_settings) !== JSON.stringify((_a = this.userSettings) === null || _a === void 0 ? void 0 : _a.client_settings)) {
                            this.onClientSettingsChanged.emit(updatedUserSettings.client_settings);
                        }
                        if (JSON.stringify(updatedUserSettings.global_settings) !== JSON.stringify((_b = this.userSettings) === null || _b === void 0 ? void 0 : _b.global_settings)) {
                            this.onGlobalSettingsChanged.emit(updatedUserSettings.global_settings);
                        }
                        this.userSettings = updatedUserSettings;
                        return [2 /*return*/, this.userSettings];
                    case 4:
                        e_10 = _c.sent();
                        this.logger.catch(e_10);
                        throw e_10;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Chariot.prototype.uploadAvatar = function (file) {
        return __awaiter(this, void 0, void 0, function () {
            var e_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (!this.auth.getState().authenticated) {
                            throw new Errors_1.OrderOfOperationsError("Attempted to update avatar before logging in.");
                        }
                        return [4 /*yield*/, this.RestApi.request({
                                path: "/avatar",
                                method: "POST",
                                body: {
                                    file: file
                                },
                                apiExpectsFormData: true
                            })];
                    case 1:
                        _a.sent();
                        this.logger.log("Uploaded user avatar");
                        return [2 /*return*/, true];
                    case 2:
                        e_11 = _a.sent();
                        this.logger.catch(e_11);
                        throw e_11;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return Chariot;
}());
exports.default = Chariot;
